import { ExtendedFirebaseInstance } from 'react-redux-firebase'
import { onIsLoading } from '../../../../utils/onLoading'
import { actions as appActions } from '../../../App/reducer'
import {
  BankAccountTypeEnum,
  Profile,
  ProfileBillTo,
  ProfileValues,
} from '../../types'

export const onError = (message: string, isProfile?: boolean) => {
  window.store.dispatch(
    appActions.onAlert({
      severity: 'error',
      message,
    })
  )
  onIsLoading(false)
  if (isProfile) return {} as Profile
  return [] as any[]
}

interface Props {
  billTo: ProfileBillTo
  profile: {
    email: string
    customerProfileId: number
  }
  data: {
    subscriptionIds: { subscriptionId: string[] }
  }
  shipToList: {
    customerAddressId: number
  }
  paymentProfile: {
    customerPaymentProfileId: number
  }
  creditCard: {
    cardNumber: string
    expirationDate: string
    cardType: string
  }
  bankAccount: {
    accountType: string
    routingNumber: string
    accountNumber: string
    nameOnAccount: string
  }
}

export const getProfileData = ({
  billTo,
  profile,
  data,
  shipToList,
  paymentProfile,
  creditCard,
  bankAccount,
}: Props): Profile => ({
  address: billTo.address,
  city: billTo.city,
  email: profile.email,
  fullName: `${billTo.firstName} ${billTo.lastName}`,
  firstName: billTo.firstName,
  customerProfileId: profile.customerProfileId,
  customerAddressId: shipToList.customerAddressId,
  lastName: billTo.lastName,
  phoneNumber: billTo.phoneNumber,
  state: billTo.state,
  zip: billTo.zip,
  cardNumber: creditCard.cardNumber || '',
  expirationDate: creditCard.expirationDate || '',
  cardType: creditCard.cardType || '',
  routingNumber: bankAccount.routingNumber || '',
  accountNumber: bankAccount.accountNumber || '',
  nameOnAccount: bankAccount.nameOnAccount || '',
  accountType:
    (bankAccount.accountType as BankAccountTypeEnum) ||
    ('' as BankAccountTypeEnum),
  customerPaymentProfileId: paymentProfile.customerPaymentProfileId,
  subscriptionIds: data.subscriptionIds
    ? data.subscriptionIds.subscriptionId
    : [],
})

export const getProfileEmailData = () => {
  const currentUser = (window.firebase as ExtendedFirebaseInstance).auth()
    .currentUser
  if (currentUser != null) {
    return {
      ...ProfileValues,
      email: String(currentUser.email),
    }
  }
  onIsLoading(false)
  return {} as Profile
}
